import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import React, {useState} from 'react';
import { ToastProvider } from '@uhg-abyss/web/ui/Toast';
import { CboCustomForm } from './CboCustomForm';
import { UserInfo } from '@src/api.types';

export type CboCustomModalProps = {
  isOpen: boolean;
  setReferResponse: (value: any) => void;
  onClose: () => void;
  setIsResultsModalOpen?: (value: boolean) => void;
};

export const CboCustomModal = ({
  isOpen,
  setReferResponse,
  onClose,
  setIsResultsModalOpen,
}: CboCustomModalProps) => {

  return (
    <div>
      <ModalDialog
        header="Next Steps"
        closeOnClickOutside={true}
        size="$md"
        isOpen={isOpen}
        onClose={onClose}
        css={{
          'abyss-modal-content-container': {
            padding: '8px',
          },
        }}
      >
        <div data-cy="cbo-custom-modal">
          <div>
            <CboCustomForm
              setReferResponse={setReferResponse}
              onClose={onClose}
              setIsResultsModalOpen={setIsResultsModalOpen}
            />
          </div>
        </div>
      </ModalDialog>
      <ToastProvider children={undefined} />
    </div>
  );
};